import styled from 'styled-components';

import { StyledButton } from '~/components/Button/styles';
import grid from '~/styles/grid';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: ${grid['5xl']};
  max-width: 918px;
  width: 100%;
  background: white;
  padding: ${grid.md} ${grid.lg};
  box-shadow: 0px 3px 20px #00000029;
  border-radius: 5px;
  z-index: 2;
`;

export const SelectedContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const OptionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${grid.sm};

  ${StyledButton} {
    display: flex;
    align-items: center;
    gap: ${grid.sm};

    padding: ${grid.md};

    span {
      font-weight: bold;
      font-size: 14px;
    }
  }
`;

export const AssignedContainer = styled.div`
  border-left: 1px solid #f4f4f4;
  margin-left: 24px;
  padding-left: 16px;

  p {
    font-size: 12px;
    color: #b4b4b4;
  }
`;

export const SelectedNumber = styled.p`
  font-size: 32px;
  font-weight: bold;
  color: #505050;
  padding: 0 ${grid.sm};
  margin: 0;
`;

export const ClearSelectionButton = styled.button`
  background: transparent;
  border: none;
  padding: ${grid.md};
`;

export const SelectedText = styled.span`
  margin-top: 2px;
`;
